import React, { FC } from "react";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import PhoneAndroidOutlinedIcon from "@mui/icons-material/PhoneAndroidOutlined";
import { useDispatch, useSelector } from "react-redux";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { setOpenCloseModalPhotos } from "../../../redux/slices/data/dataSampleView";
import { State } from "../../../redux/slices";
import { v4 as uuidv4 } from "uuid";

import moment from "moment";
import { useTranslation } from "react-i18next";
import { selectLocale } from "../../../redux/slices/layout";
import { Alert } from "@mui/material";
import { ListOfIcons } from "../icons/Icons";

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  return {
    setOpenCloseModalPhotos: (visible: boolean) => {
      dispatch(setOpenCloseModalPhotos(visible));
    },
  };
};

export const findTheName = (
  textId: number | undefined,
  texts: { [key: string]: string } | undefined,
) => {
  if (!texts || !textId) return "";
  return texts[textId.toString()];
};

const DataSampleViewLeft: FC = () => {
  const [t] = useTranslation("global");
  const { photos, sampleViewInfo } = useSelector(
    (state: State) => state.DataSampleViewReducer,
  );

  const foundIcon = ListOfIcons.find(
    (item) => item.cerealTypeId === sampleViewInfo?.cerealTypeId,
  )?.icon;

  const locale = useSelector(selectLocale);
  const { setOpenCloseModalPhotos } = SetActions();

  const creator = sampleViewInfo?.username ? (
    <span className="creator-action-details">{sampleViewInfo.username}</span>
  ) : (
    <span className="creator-action-details">
      {t("Data.SampleView.No_user_info")}
    </span>
  );
  const createdAt = moment(sampleViewInfo?.createdAt);
  createdAt.locale(locale);
  const createdAtModify = createdAt.format("l, LT");
  const locationName = sampleViewInfo?.geoPointName
    ? sampleViewInfo?.geoPointName
    : t("Data.table.No_geo_point");
  const deviceName = sampleViewInfo?.pastAction?.device?.orgInternalId;

  const texts = sampleViewInfo?.texts as { [key: string]: string } | undefined;
  const cropTextId = sampleViewInfo?.cropTextId;

  return (
    <div className="details-left-side">
      <div className="origine">
        <div className="title-sections-sample-view">{t("Data.Origin")}</div>
        <div className="origin-card">
          <div className="action-container">
            <div
              className="action-card"
              style={{
                backgroundColor:
                  sampleViewInfo?.cerealType?.iconBackgroundHexColor,
              }}
            >
              <div className="scenario-info-card">
                {foundIcon ? (
                  React.cloneElement(
                    foundIcon as React.ReactElement<
                      React.SVGProps<SVGSVGElement>
                    >,
                    {
                      style: {
                        color:
                          sampleViewInfo?.cerealType?.iconForegroundHexColor,
                        width: "40px",
                        height: "40px",
                      },
                    },
                  )
                ) : (
                  <span
                    style={{
                      color: sampleViewInfo?.cerealType?.iconForegroundHexColor,
                    }}
                  >
                    {findTheName(cropTextId, texts)}
                  </span>
                )}
              </div>
            </div>
            <div className="action-info">
              <div className="action-info-row">
                <PersonOutlineIcon className="action-info-icon" />
                {creator}
              </div>
              <div className="action-info-row">
                <CalendarTodayOutlinedIcon className="action-info-icon" />
                <span>{createdAtModify}</span>
              </div>
              <div className="action-info-row">
                <LocationOnOutlinedIcon className="action-info-icon" />
                <span>{locationName}</span>
              </div>
              <div className="action-info-row">
                <PhoneAndroidOutlinedIcon className="action-info-icon" />
                <span>
                  {deviceName ? (
                    <>{deviceName}</>
                  ) : (
                    <>{t("Common_options.null")}</>
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="photos-container">
        <div className="photos-card">
          <div className="title-sections-sample-view mb-3">
            {t("Data.Photos")}
          </div>
          <div className="photos-actions">
            {photos.length > 0 ? (
              photos.map((photo: { signedRequest: string }) => (
                <button
                  key={`${photo.signedRequest}${uuidv4()}`}
                  className="photos-actions-2"
                  onClick={() => setOpenCloseModalPhotos(true)}
                >
                  <img
                    className="photo-style-cereal"
                    src={photo.signedRequest}
                    alt="cereal"
                  />
                  <div className="overlay">
                    <div className="text">
                      <ZoomInIcon fontSize="large" />
                    </div>
                  </div>
                </button>
              ))
            ) : (
              <Alert severity="warning" className="mt-4">
                {t("Data.SampleView.No_photos")}
              </Alert>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataSampleViewLeft;
